export const blogArticles = [
  {
    slug: '/blog/invoice-payment-terms',
    title: 'Invoice Payment Terms Explained',
    excerpt: 'Net 30, Net 15, Due on Receipt, 2/10 Net 30 — what every term means and when to use it.',
    category: 'Payment Terms',
  },
  {
    slug: '/blog/what-does-due-upon-receipt-mean',
    title: 'What Does "Due Upon Receipt" Mean?',
    excerpt: 'Definition, synonyms, how it compares to Net 30, and when to use it on your invoices.',
    category: 'Payment Terms',
  },
  {
    slug: '/blog/net-15-payment-terms',
    title: 'Net 15 Payment Terms Explained',
    excerpt: 'What Net 15 means, how it compares to Net 30, and who uses it.',
    category: 'Payment Terms',
  },
  {
    slug: '/blog/late-payment-follow-up-email',
    title: 'Late Payment Follow-Up Email Templates',
    excerpt: 'Copy-paste email scripts to chase overdue invoices — politely and firmly.',
    category: 'Payment Terms',
  },
  {
    slug: '/blog/vat-invoice-requirements-uk',
    title: 'UK VAT Invoice Requirements',
    excerpt: 'HMRC mandatory fields, full vs simplified vs modified VAT invoice types.',
    category: 'UK VAT',
  },
  {
    slug: '/blog/simplified-vat-invoice',
    title: 'Simplified VAT Invoice Guide',
    excerpt: 'The £250 threshold, required fields, and who can use a simplified VAT invoice.',
    category: 'UK VAT',
  },
  {
    slug: '/blog/uk-invoice-requirements',
    title: 'UK Invoice Requirements (Non-VAT)',
    excerpt: 'What sole traders and limited companies must include on invoices even without VAT registration.',
    category: 'UK Invoicing',
  },
  {
    slug: '/blog/how-to-create-gst-invoice-india',
    title: 'How to Create a GST Invoice in India',
    excerpt: 'GSTIN, HSN/SAC codes, IGST vs CGST/SGST — everything required by the CBIC.',
    category: 'GST India',
  },
  {
    slug: '/blog/gst-invoice-format-india',
    title: 'GST Invoice Format India',
    excerpt: 'GST invoice format requirements under Rule 46 of the CGST Rules, 2017.',
    category: 'GST India',
  },
  {
    slug: '/blog/how-to-calculate-gst-invoice',
    title: 'How to Calculate GST on an Invoice',
    excerpt: 'GST formula, worked examples at 5%/12%/18%/28%, and reverse GST calculation.',
    category: 'GST India',
  },
  {
    slug: '/blog/australia-tax-invoice-guide',
    title: 'Australian Tax Invoice Requirements',
    excerpt: 'ATO rules: ABN, GST at 10%, the $82.50 threshold, and the $1,000 buyer identity rule.',
    category: 'Australia',
  },
  {
    slug: '/blog/self-employed-invoice-guide',
    title: 'Self-Employed Invoice Guide',
    excerpt: 'How to invoice as a sole trader in the UK, Australia, US, and EU.',
    category: 'Freelancing',
  },
  {
    slug: '/blog/what-to-include-freelance-invoice',
    title: 'What to Include on a Freelance Invoice',
    excerpt: 'Complete checklist of every field a freelance invoice should have.',
    category: 'Freelancing',
  },
  {
    slug: '/blog/how-to-invoice-international-clients',
    title: 'How to Invoice International Clients',
    excerpt: 'Currency choice, VAT/GST on exports, SWIFT payments, and reducing transfer fees.',
    category: 'International',
  },
  {
    slug: '/blog/invoice-vs-receipt',
    title: 'Invoice vs Receipt — Key Differences',
    excerpt: 'When to issue an invoice vs a receipt, and why the distinction matters for tax.',
    category: 'Basics',
  },
  {
    slug: '/blog/how-to-number-invoices',
    title: 'How to Number Invoices',
    excerpt: 'Sequential, date-based, and client-based numbering systems — and HMRC/CBIC rules.',
    category: 'Basics',
  },
  {
    slug: '/blog/how-to-invoice-as-a-coach-uk',
    title: 'How to Invoice as a Coach in the UK',
    excerpt: 'VAT rules for coaching services, HMRC self-assessment, and what to include on a UK coaching invoice.',
    category: 'UK Invoicing',
  },
  {
    slug: '/blog/how-to-invoice-as-freelancer-nigeria',
    title: 'How to Invoice as a Freelancer in Nigeria',
    excerpt: 'FIRS TIN registration, USD billing, VAT on exports, and how to receive international payments in Nigeria.',
    category: 'International',
  },
  {
    slug: '/blog/how-to-invoice-clients-kenya',
    title: 'How to Invoice Clients in Kenya',
    excerpt: 'KRA PIN, eTIMS electronic invoicing, M-Pesa payment details, and the 16% VAT threshold.',
    category: 'International',
  },
  {
    slug: '/blog/how-to-invoice-as-freelancer-south-africa',
    title: 'How to Invoice as a Freelancer in South Africa',
    excerpt: 'SARS VAT rules, 15% VAT threshold (R1M), full vs abridged tax invoices, and how to receive international payments.',
    category: 'International',
  },
  {
    slug: '/blog/how-to-invoice-as-personal-trainer-uk',
    title: 'How to Invoice as a Personal Trainer in the UK',
    excerpt: 'HMRC self-assessment, 20% VAT rules for PT services, session vs monthly billing, and allowable expenses.',
    category: 'UK Invoicing',
  },
  {
    slug: '/blog/how-to-invoice-as-photographer-uk',
    title: 'How to Invoice as a Photographer in the UK',
    excerpt: 'Deposit invoicing, image licensing fees, day rate invoicing, VAT at 20%, and HMRC rules for UK photographers.',
    category: 'UK Invoicing',
  },
];

// Related article slugs per page (3 most relevant)
export const relatedMap = {
  '/blog/invoice-payment-terms': [
    '/blog/what-does-due-upon-receipt-mean',
    '/blog/net-15-payment-terms',
    '/blog/late-payment-follow-up-email',
  ],
  '/blog/what-does-due-upon-receipt-mean': [
    '/blog/invoice-payment-terms',
    '/blog/net-15-payment-terms',
    '/blog/late-payment-follow-up-email',
  ],
  '/blog/net-15-payment-terms': [
    '/blog/invoice-payment-terms',
    '/blog/what-does-due-upon-receipt-mean',
    '/blog/late-payment-follow-up-email',
  ],
  '/blog/late-payment-follow-up-email': [
    '/blog/invoice-payment-terms',
    '/blog/what-does-due-upon-receipt-mean',
    '/blog/net-15-payment-terms',
  ],
  '/blog/vat-invoice-requirements-uk': [
    '/blog/simplified-vat-invoice',
    '/blog/uk-invoice-requirements',
    '/blog/self-employed-invoice-guide',
  ],
  '/blog/simplified-vat-invoice': [
    '/blog/vat-invoice-requirements-uk',
    '/blog/uk-invoice-requirements',
    '/blog/self-employed-invoice-guide',
  ],
  '/blog/uk-invoice-requirements': [
    '/blog/vat-invoice-requirements-uk',
    '/blog/simplified-vat-invoice',
    '/blog/self-employed-invoice-guide',
  ],
  '/blog/how-to-create-gst-invoice-india': [
    '/blog/gst-invoice-format-india',
    '/blog/how-to-calculate-gst-invoice',
    '/blog/invoice-vs-receipt',
  ],
  '/blog/gst-invoice-format-india': [
    '/blog/how-to-create-gst-invoice-india',
    '/blog/how-to-calculate-gst-invoice',
    '/blog/invoice-vs-receipt',
  ],
  '/blog/how-to-calculate-gst-invoice': [
    '/blog/how-to-create-gst-invoice-india',
    '/blog/gst-invoice-format-india',
    '/blog/invoice-vs-receipt',
  ],
  '/blog/australia-tax-invoice-guide': [
    '/blog/self-employed-invoice-guide',
    '/blog/invoice-payment-terms',
    '/blog/invoice-vs-receipt',
  ],
  '/blog/self-employed-invoice-guide': [
    '/blog/what-to-include-freelance-invoice',
    '/blog/invoice-payment-terms',
    '/blog/how-to-invoice-international-clients',
  ],
  '/blog/what-to-include-freelance-invoice': [
    '/blog/self-employed-invoice-guide',
    '/blog/invoice-payment-terms',
    '/blog/how-to-invoice-international-clients',
  ],
  '/blog/how-to-invoice-international-clients': [
    '/blog/what-to-include-freelance-invoice',
    '/blog/self-employed-invoice-guide',
    '/blog/invoice-payment-terms',
  ],
  '/blog/invoice-vs-receipt': [
    '/blog/how-to-create-gst-invoice-india',
    '/blog/self-employed-invoice-guide',
    '/blog/invoice-payment-terms',
  ],
  '/blog/how-to-number-invoices': [
    '/blog/self-employed-invoice-guide',
    '/blog/invoice-payment-terms',
    '/blog/what-to-include-freelance-invoice',
  ],
  '/blog/how-to-invoice-as-a-coach-uk': [
    '/blog/uk-invoice-requirements',
    '/blog/vat-invoice-requirements-uk',
    '/blog/self-employed-invoice-guide',
  ],
  '/blog/how-to-invoice-as-freelancer-nigeria': [
    '/blog/how-to-invoice-international-clients',
    '/blog/how-to-invoice-clients-kenya',
    '/blog/self-employed-invoice-guide',
  ],
  '/blog/how-to-invoice-clients-kenya': [
    '/blog/how-to-invoice-international-clients',
    '/blog/how-to-invoice-as-freelancer-nigeria',
    '/blog/self-employed-invoice-guide',
  ],
  '/blog/how-to-invoice-as-freelancer-south-africa': [
    '/blog/how-to-invoice-international-clients',
    '/blog/self-employed-invoice-guide',
    '/blog/what-to-include-freelance-invoice',
  ],
  '/blog/how-to-invoice-as-personal-trainer-uk': [
    '/blog/uk-invoice-requirements',
    '/blog/vat-invoice-requirements-uk',
    '/blog/self-employed-invoice-guide',
  ],
  '/blog/how-to-invoice-as-photographer-uk': [
    '/blog/uk-invoice-requirements',
    '/blog/vat-invoice-requirements-uk',
    '/blog/self-employed-invoice-guide',
  ],
};
